import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { LinkText } from '@/components/ui/Typography/Body/LinkText';
import { openFileNewTab } from '@/utils/file/open';
/**
 * 画像一覧表示（Item）
 * @param props
 * @returns
 */
export const FlatFileListItem = (props) => {
    const { className = '', file = null, name = '', path } = props;
    const fileValues = file instanceof FileList ? file.item(0) : file;
    /**
     * ファイルを開く
     */
    const onClickFileLink = useCallback(() => {
        openFileNewTab(path || fileValues);
    }, [path, fileValues]);
    return (_jsx("li", Object.assign({ className: className }, { children: _jsx("button", Object.assign({ onClick: onClickFileLink, type: 'button' }, { children: _jsx(LinkText, Object.assign({ size: 'sm' }, { children: name || (fileValues === null || fileValues === void 0 ? void 0 : fileValues.name) || '-' })) })) })));
};
